import { Link } from '@coolblue-development/freddy';
import selectAlternativeTrigger from '@coolblue-development/ga4-events/triggers/AlternativePrimaryItem/selectAlternativeTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { PromotionalProductImage } from '@coolblue-development/next-patterns/core';

import type { ProductCardProps } from './ProductCard';

export const PromotionalProductImageVariant = ({
  cbcLabel,
  isCurrentProduct,
  product,
  trackingProps
}: ProductCardProps) => {
  const { trackEvent } = useAnalytics();
  const promotionalProductImage = (
    <PromotionalProductImage
      alt='' // As the product name is displayed, the alt attribute is redundant here.
      size='small'
      imageId={product.primaryImage.id}
      loading='lazy'
      primaryLabel={cbcLabel ? cbcLabel : null}
      imageSizes='(min-width: 1020px) 394px, (min-width: 440px) 137px, 129px'
    />
  );

  if (isCurrentProduct || !product?.urls?.product) {
    return promotionalProductImage;
  }

  return (
    <Link
      aria-hidden
      tabIndex={-1}
      href={product?.urls?.product}
      onClick={() =>
        trackEvent(
          selectAlternativeTrigger({
            index: trackingProps.index,
            total_indices: trackingProps.totalIndices,
            method: 'image',
            item_id: product.id
          })
        )
      }
    >
      {promotionalProductImage}
    </Link>
  );
};
